
import InlineSvg from 'vue-inline-svg';
import {capitalize} from "lodash-es";

import {defineComponent, ref} from 'vue';

export default defineComponent({
    props: {
        networks: {
            type: Array<'facebook' | 'linkedin' | 'twitter' | 'link' | 'instagram'>
        },
        flashMessage: String
    },
    components: {
        InlineSvg
    },
    setup() {
        const url = window.location.href;
        const title: HTMLMetaElement | string = document.title || (document.querySelector("meta[property='og:title']")?.getAttribute('content') as string);

        let timer: number, isFlashMsgActive = ref(false);

        const handleLinkShare = async () => {
            if (navigator.share) {
                await navigator.share({
                    title: title,
                    url: window.location.href
                }).catch(console.error);
            } else {
                await navigator.clipboard.writeText(window.location.href);
                await clearTimeout(timer);
                isFlashMsgActive.value = true;
                timer = window.setTimeout(() => {
                    isFlashMsgActive.value = false;
                }, 5000);
            }
        }

        return {url, title, isFlashMsgActive, capitalize, handleLinkShare}
    }
})
